// extracted by mini-css-extract-plugin
export default {"projectView-container":"ProjectPage_projectView-container__W7yg4","tabs-container":"ProjectPage_tabs-container__SO6mf","content-container":"ProjectPage_content-container__BzCWk"};